import { all, takeEvery, put, call } from 'redux-saga/effects';
import { sendRequest } from 'src/helpers/saga';
import { logger } from 'src/helpers/logger';
import Api from 'src/helpers/api';
import { tableConfig } from 'src/settings';
import actions from './actions';
import notifications from '../../redux/notifications/actions';

const searchApi = new Api('search');
const recentApi = new Api('search/recent');
const clickApi = new Api('search/:id/click');

function* search({ payload }) {
  try {
    const { page = 1, pageSize = tableConfig.pageSize, query } = payload;

    const result = yield call(
      sendRequest,
      searchApi.load,
      {
        search: {
          page,
          page_size: pageSize,
          query,
        },
      },
      notifications.REQUEST_ERROR,
    );

    if (result?.data?.success?.data?.records) {
      const { records, total_count } = result.data.success.data;

      yield put(actions.searchSuccess({ records, page, total_count }));
    } else {
      yield put(actions.searchError());
    }
  } catch (error) {
    logger.error(error);
  }
}

function* getRecent() {
  try {
    const result = yield call(sendRequest, recentApi.load, {}, notifications.REQUEST_ERROR);

    if (result?.data?.success?.data?.records) {
      const { records } = result.data.success.data;

      yield put(actions.getRecentSuccess({ records }));
    } else {
      yield put(actions.getRecentError());
    }
  } catch (error) {
    logger.error(error);
  }
}

function* clickItem({ payload }) {
  const { id } = payload;

  try {
    const result = yield call(sendRequest, clickApi.createItem, { id }, notifications.REQUEST_ERROR);

    if (result) {
      yield put(actions.clickItemSuccess());
    } else {
      yield put(actions.clickItemError());
    }
  } catch (error) {
    logger.error(error);
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.SEARCH_REQUEST, search)]);
  yield all([takeEvery(actions.GET_RECENT_REQUEST, getRecent)]);
  yield all([takeEvery(actions.CLICK_ITEM_REQUEST, clickItem)]);
}
